import React from "react";
import { FormattedMessage } from "react-intl";
export var NotFoundScreen = function () {
    return (React.createElement("div", { className: "flex-1 min-w-0 flex flex-col bg-gray-100" },
        React.createElement("div", { className: "mt-[4.5rem] text-sm leading-5 font-normal text-center text-[#605E5C]" },
            React.createElement(FormattedMessage, { id: "pageNotFound" }))));
};
